<template>
  <section>
    <RequestKitsThanksHero header="REQUEST KITS"
                           paragraph="Thank you for your request. Our sun safety squad will get right on it. Please allow 4–6 weeks for your kits to arrive."
                           image="Super-Sam-SunHero-300-large"/>
  </section>
</template>
<script>
import RequestKitsThanksHero from '../thanks/RequestKitsThanksHero.vue'

export default {
  components: {
    RequestKitsThanksHero
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";
// section {
//   height: 50vh;
// }
</style>
